import { LocalizationKeys, type Translations } from "../keys";
import { enRegionTranslations } from "./regions/en";

export const enTranslations: Translations = {
  [LocalizationKeys.COMMON_LOADING]: "Loading...",
  [LocalizationKeys.COMMON_ERROR]: "Error",
  [LocalizationKeys.COMMON_SAVE]: "Save",
  [LocalizationKeys.COMMON_CANCEL]: "Cancel",
  [LocalizationKeys.COMMON_DELETE]: "Delete",
  [LocalizationKeys.COMMON_DELETING]: "Deleting...",
  [LocalizationKeys.COMMON_YES]: "Yes",
  [LocalizationKeys.COMMON_EDIT]: "Edit",
  [LocalizationKeys.COMMON_BACK]: "Back",
  [LocalizationKeys.COMMON_NO_RESULTS]: "No results",
  [LocalizationKeys.COMMON_VIEW_ALL]: "View all",
  [LocalizationKeys.COMMON_RESULT]: "result",
  [LocalizationKeys.COMMON_RESULTS]: "results",

  // View mode keys
  [LocalizationKeys.VIEW_MODE_TOGGLE]: "Toggle view mode",
  [LocalizationKeys.VIEW_MODE_GRID]: "Grid view",
  [LocalizationKeys.VIEW_MODE_LIST]: "List view",

  // Text editor keys
  [LocalizationKeys.TEXT_EDITOR_BOLD]: "Bold (Ctrl+B)",
  [LocalizationKeys.TEXT_EDITOR_ITALIC]: "Italic (Ctrl+I)",
  [LocalizationKeys.TEXT_EDITOR_UNDERLINE]: "Underline (Ctrl+U)",
  [LocalizationKeys.TEXT_EDITOR_STRIKETHROUGH]: "Strikethrough",
  [LocalizationKeys.TEXT_EDITOR_HEADING]: "Heading",
  [LocalizationKeys.TEXT_EDITOR_QUOTE]: "Quote",
  [LocalizationKeys.TEXT_EDITOR_LIST]: "List",
  [LocalizationKeys.TEXT_EDITOR_LINK]: "Link",
  [LocalizationKeys.TEXT_EDITOR_PLACEHOLDER]: "Enter text...",
  [LocalizationKeys.TEXT_EDITOR_PREVIEW]: "Preview",

  [LocalizationKeys.HEADER_SEARCH]: "Search...",
  [LocalizationKeys.HEADER_NOTIFICATIONS]: "Notifications",
  [LocalizationKeys.HEADER_PROFILE]: "Profile",

  [LocalizationKeys.AUTH_SIGN_IN]: "Sign In",
  [LocalizationKeys.AUTH_SIGN_UP]: "Sign Up",
  [LocalizationKeys.AUTH_LOGOUT]: "Logout",
  [LocalizationKeys.AUTH_EMAIL]: "Email",
  [LocalizationKeys.AUTH_PASSWORD]: "Password",
  [LocalizationKeys.AUTH_USERNAME]: "Username",
  [LocalizationKeys.AUTH_PROMPT_MESSAGE]: "Sign in to track your progress",
  [LocalizationKeys.AUTH_PROMPT_TITLE]:
    "This feature is only available for registered users",
  [LocalizationKeys.AUTH_PROMPT_SUBTITLE]: "Join us — with an account you can:",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_TRACK]:
    "Track what you've watched, read, or played — never lose sight of it",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_REVIEWS]:
    "Write reviews and share your impressions",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_COLLECTIONS]:
    'Create collections: "Best for Weekend", "For the Evening" and more',
  [LocalizationKeys.AUTH_PROMPT_FEATURE_DISCUSS]:
    "Discuss new releases and share theories",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_NOTIFICATIONS]:
    "Get notifications about new episodes and releases",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_SOCIAL]:
    "Follow friends and see their recommendations",

  [LocalizationKeys.COMMON_CLOSE]: "Close",

  [LocalizationKeys.PROFILE_OPEN_PROFILE]: "Open profile",
  [LocalizationKeys.PROFILE_THEME]: "Theme",
  [LocalizationKeys.PROFILE_LANGUAGE]: "Language",
  [LocalizationKeys.PROFILE_SETTINGS]: "Settings",

  [LocalizationKeys.MENU_SELECT_THEME]: "Select Theme",
  [LocalizationKeys.MENU_SELECT_LANGUAGE]: "Select Language",
  [LocalizationKeys.MENU_BACK_TO_MENU]: "Back to menu",
  [LocalizationKeys.MENU_LANGUAGE_CHANGED]: "Language changed (not synced to server)",
  [LocalizationKeys.MENU_THEME_CHANGED]: "Theme changed (not synced to server)",

  [LocalizationKeys.THEME_LIGHT]: "Light",
  [LocalizationKeys.THEME_DARK]: "Dark",
  [LocalizationKeys.THEME_SYSTEM]: "Auto",

  [LocalizationKeys.LANGUAGE_SYSTEM]: "Auto",
  [LocalizationKeys.LANGUAGE_RU]: "Русский",
  [LocalizationKeys.LANGUAGE_EN]: "English",
  [LocalizationKeys.LANGUAGE_ES]: "Español",
  [LocalizationKeys.LANGUAGE_FR]: "Français",
  [LocalizationKeys.LANGUAGE_DE]: "Deutsch",
  [LocalizationKeys.LANGUAGE_ZH]: "中文",
  [LocalizationKeys.LANGUAGE_IN]: "हिन्दी",
  [LocalizationKeys.LANGUAGE_PT]: "Português",

  [LocalizationKeys.CONSUME_TYPE_UNSPECIFIED]: "Not watched",
  [LocalizationKeys.CONSUME_TYPE_WATCHING]: "Watching",
  [LocalizationKeys.CONSUME_TYPE_WATCHED]: "Watched",
  [LocalizationKeys.CONSUME_TYPE_DELAYED]: "Delayed",
  [LocalizationKeys.CONSUME_TYPE_TRASH]: "Dropped",

  [LocalizationKeys.GENDER_UNSPECIFIED]: "Not specified",
  [LocalizationKeys.GENDER_MALE]: "Male",
  [LocalizationKeys.GENDER_FEMALE]: "Female",
  [LocalizationKeys.GENDER_OTHER]: "Other",

  [LocalizationKeys.CONTENT_TYPE_UNSPECIFIED]: "Not specified",
  [LocalizationKeys.CONTENT_TYPE_MOVIE]: "Movie",
  [LocalizationKeys.CONTENT_TYPE_BOOK]: "Book",
  [LocalizationKeys.CONTENT_TYPE_TV_SHOW]: "TV Show",
  [LocalizationKeys.CONTENT_TYPE_COMICS]: "Comics",
  [LocalizationKeys.CONTENT_TYPE_GAME]: "Game",

  [LocalizationKeys.CONTENT_STATUS_COMPLETED]: "Completed",
  [LocalizationKeys.CONTENT_STATUS_PLANNED]: "Planned",
  [LocalizationKeys.CONTENT_STATUS_IN_PROGRESS]: "In Progress",
  [LocalizationKeys.CONTENT_STATUS_CANCELLED]: "Cancelled",

  [LocalizationKeys.NAV_MOVIES]: "Movies",
  [LocalizationKeys.NAV_TV_SHOWS]: "TV Shows",
  [LocalizationKeys.NAV_GAMES]: "Games",
  [LocalizationKeys.NAV_BOOKS]: "Books",
  [LocalizationKeys.NAV_COMICS]: "Comics",
  [LocalizationKeys.NAV_COLLECTIONS]: "Collections",
  [LocalizationKeys.NAV_REVIEWS]: "Reviews",
  [LocalizationKeys.NAV_FAVORITES]: "Favorites",
  [LocalizationKeys.NAV_HISTORY]: "History",
  [LocalizationKeys.NAV_SETTINGS]: "Settings",
  [LocalizationKeys.NAV_ABOUT]: "About",

  [LocalizationKeys.A_SEARCH_BUTTON]: "See results",
  [LocalizationKeys.A_SEARCH_CATEGORY]: "Category",
  [LocalizationKeys.A_SEARCH_GENRE]: "Genre",
  [LocalizationKeys.A_SEARCH_NAME]: "Name",
  [LocalizationKeys.A_SEARCH_NAME_PLACEHOLDER]: "Enter content name",
  [LocalizationKeys.A_SEARCH_NAME_LABEL]: "Filter by content name",
  [LocalizationKeys.A_SEARCH_RELEASE_DATE]: "Release Date",
  [LocalizationKeys.A_SEARCH_DATE_FROM_PLACEHOLDER]: "From",
  [LocalizationKeys.A_SEARCH_DATE_FROM_LABEL]: "Release date from",
  [LocalizationKeys.A_SEARCH_DATE_TO_PLACEHOLDER]: "To",
  [LocalizationKeys.A_SEARCH_DATE_TO_LABEL]: "Release date to",
  [LocalizationKeys.A_SEARCH_RATING]: "Rating",
  [LocalizationKeys.A_SEARCH_RATING_RANGE]: "Rating Range",
  [LocalizationKeys.A_SEARCH_RATING_PLATFORM_PLACEHOLDER]: "Select platform",
  [LocalizationKeys.A_SEARCH_RATING_PLATFORM_LABEL]: "Rating platform",
  [LocalizationKeys.A_SEARCH_RATING_FROM_PLACEHOLDER]: "From",
  [LocalizationKeys.A_SEARCH_RATING_FROM_LABEL]: "Rating from",
  [LocalizationKeys.A_SEARCH_RATING_TO_PLACEHOLDER]: "To",
  [LocalizationKeys.A_SEARCH_RATING_TO_LABEL]: "Rating to",
  [LocalizationKeys.A_SEARCH_RATING_INVALID_FORMAT]:
    "Invalid rating. Enter a number between 0 and 10",
  [LocalizationKeys.A_SEARCH_COUNTRY]: "Country",
  [LocalizationKeys.A_SEARCH_COUNTRY_PLACEHOLDER]: "Select country",
  [LocalizationKeys.A_SEARCH_COUNTRY_LABEL]: "Filter by country",
  [LocalizationKeys.A_SEARCH_DURATION]: "Duration",
  [LocalizationKeys.A_SEARCH_DURATION_FROM_PLACEHOLDER]: "From",
  [LocalizationKeys.A_SEARCH_DURATION_FROM_LABEL]: "Duration from",
  [LocalizationKeys.A_SEARCH_DURATION_TO_PLACEHOLDER]: "To",
  [LocalizationKeys.A_SEARCH_DURATION_TO_LABEL]: "Duration to",
  [LocalizationKeys.A_SEARCH_DURATION_INVALID_FORMAT]:
    "Invalid duration. Enter a positive number",
  [LocalizationKeys.A_SEARCH_PARTICIPANTS]: "Participants",
  [LocalizationKeys.A_SEARCH_PARTICIPANTS_PLACEHOLDER]:
    "Search for actor, director, etc.",
  [LocalizationKeys.A_SEARCH_PARTICIPANTS_LABEL]: "Filter by participants",
  [LocalizationKeys.A_SEARCH_PARTICIPANTS_MIN_CHARS]:
    "Enter at least 3 characters to search",
  [LocalizationKeys.A_SEARCH_FILTERS_TITLE]: "Search filters:",
  [LocalizationKeys.A_SEARCH_EXPAND_ALL]: "Expand all",
  [LocalizationKeys.A_SEARCH_COLLAPSE_ALL]: "Collapse all",
  [LocalizationKeys.A_SEARCH_STATUS]: "Status",
  [LocalizationKeys.A_SEARCH_EMPTY_PLACEHOLDER]:
    'Select filters and click "See results"',
  [LocalizationKeys.A_SEARCH_EMPTY_RESULTS]: "No results found. Try changing your filters.",
  [LocalizationKeys.A_SEARCH_CLEAR_FILTERS]: "Clear all",

  [LocalizationKeys.GENRE_UNSPECIFIED]: "Unspecified",
  [LocalizationKeys.GENRE_ACTION]: "Action",
  [LocalizationKeys.GENRE_ADVENTURE]: "Adventure",
  [LocalizationKeys.GENRE_ANIMATION]: "Animation",
  [LocalizationKeys.GENRE_BIOGRAPHY]: "Biography",
  [LocalizationKeys.GENRE_COMEDY]: "Comedy",
  [LocalizationKeys.GENRE_CRIME]: "Crime",
  [LocalizationKeys.GENRE_DOCUMENTARY]: "Documentary",
  [LocalizationKeys.GENRE_DRAMA]: "Drama",
  [LocalizationKeys.GENRE_FAMILY]: "Family",
  [LocalizationKeys.GENRE_FANTASY]: "Fantasy",
  [LocalizationKeys.GENRE_FILM_NOIR]: "Film Noir",
  [LocalizationKeys.GENRE_GAME_SHOW]: "Game Show",
  [LocalizationKeys.GENRE_HISTORY]: "History",
  [LocalizationKeys.GENRE_HORROR]: "Horror",
  [LocalizationKeys.GENRE_MUSIC]: "Music",
  [LocalizationKeys.GENRE_MUSICAL]: "Musical",
  [LocalizationKeys.GENRE_NEWS]: "News",
  [LocalizationKeys.GENRE_REALITY_TV]: "Reality TV",
  [LocalizationKeys.GENRE_ROMANCE]: "Romance",
  [LocalizationKeys.GENRE_SCI_FI]: "Sci-Fi",
  [LocalizationKeys.GENRE_SHORT]: "Short",
  [LocalizationKeys.GENRE_SPORT]: "Sport",
  [LocalizationKeys.GENRE_TALK_SHOW]: "Talk Show",
  [LocalizationKeys.GENRE_THRILLER]: "Thriller",
  [LocalizationKeys.GENRE_WAR]: "War",
  [LocalizationKeys.GENRE_WESTERN]: "Western",

  [LocalizationKeys.PLATFORM_UNSPECIFIED]: "Unspecified",
  [LocalizationKeys.PLATFORM_IMDB]: "IMDb",
  [LocalizationKeys.PLATFORM_KINOPOISK]: "Kinopoisk",

  [LocalizationKeys.SEARCH_ALL]: "All",
  [LocalizationKeys.SEARCH_CONTENT]: "Content",
  [LocalizationKeys.SEARCH_MOVIES]: "Movies",
  [LocalizationKeys.SEARCH_TV_SHOWS]: "TV Shows",
  [LocalizationKeys.SEARCH_BOOKS]: "Books",
  [LocalizationKeys.SEARCH_COMICS]: "Comics",
  [LocalizationKeys.SEARCH_GAMES]: "Games",
  [LocalizationKeys.SEARCH_USERS]: "Users",
  [LocalizationKeys.SEARCH_PERSONS]: "Persons",
  [LocalizationKeys.SEARCH_COLLECTIONS]: "Collections",
  [LocalizationKeys.SEARCH_FAVORITES]: "Favorites",
  [LocalizationKeys.SEARCH_USER]: "User",
  [LocalizationKeys.SEARCH_COMMUNITY]: "Community",
  [LocalizationKeys.SEARCH_SEARCHING]: "Searching...",
  [LocalizationKeys.SEARCH_NO_RESULTS]: "No results found",
  [LocalizationKeys.SEARCH_USER_REPUTATION]: "Reputation",

  [LocalizationKeys.NOTIFICATION_JUST_NOW]: "Just now",
  [LocalizationKeys.NOTIFICATION_MINUTES_AGO]: "{0}m ago",
  [LocalizationKeys.NOTIFICATION_HOURS_AGO]: "{0}h ago",
  [LocalizationKeys.NOTIFICATION_DAYS_AGO]: "{0}d ago",
  [LocalizationKeys.NOTIFICATION_WEEKS_AGO]: "{0}w ago",
  [LocalizationKeys.NOTIFICATION_MONTHS_AGO]: "{0}mo ago",
  [LocalizationKeys.NOTIFICATION_YEARS_AGO]: "{0}y ago",
  [LocalizationKeys.NOTIFICATION_MARK_ALL_READ]: "Mark all as read",
  [LocalizationKeys.NOTIFICATION_NO_NEW]: "No new notifications",
  [LocalizationKeys.NOTIFICATION_UNREAD_COUNT]: "{0} unread notification",
  [LocalizationKeys.NOTIFICATION_EMPTY_STATE]:
    "Notifications will appear here when they arrive.",
  [LocalizationKeys.NOTIFICATION_LOADING_MORE]: "Loading more...",
  [LocalizationKeys.NOTIFICATION_LOAD_ERROR]: "Failed to load notifications",

  // Favourites action keys
  [LocalizationKeys.FAVOURITES_FAVOURITE]: "Favourite",
  [LocalizationKeys.FAVOURITES_MUTE]: "Mute",
  [LocalizationKeys.FAVOURITES_UNMUTE]: "Unmute",
  [LocalizationKeys.FAVOURITES_UNFAVOURITE]: "Unfavourite",

  // Add to collection popup keys
  [LocalizationKeys.ADD_TO_COLLECTION_TITLE]:
    "Select a collection to add this content to",
  [LocalizationKeys.ADD_TO_COLLECTION_CREATE_NEW]: "Create new collection",
  [LocalizationKeys.CREATE_COLLECTION_TITLE]: "Create New Collection",
  [LocalizationKeys.CREATE_COLLECTION_BUTTON]: "Create",
  [LocalizationKeys.ADD_TO_COLLECTION_NO_COLLECTIONS]:
    "You don't have any collections yet",
  [LocalizationKeys.ADD_TO_COLLECTION_LOADING]: "Loading collections...",
  [LocalizationKeys.ADD_TO_COLLECTION_ERROR]: "Failed to load collections",
  [LocalizationKeys.ADD_TO_COLLECTION_SUCCESS]: "Content added to collection",

  // Collection item keys
  [LocalizationKeys.COLLECTION_AUTHOR_NOTE]: "Author's note",
  [LocalizationKeys.COLLECTION_NOTE_PLACEHOLDER]: "Add a note for this item...",

  // Collection form keys
  [LocalizationKeys.COLLECTION_TITLE]: "Collection title",
  [LocalizationKeys.COLLECTION_TITLE_PLACEHOLDER]: "Enter collection title",
  [LocalizationKeys.COLLECTION_DESCRIPTION]: "Description",
  [LocalizationKeys.COLLECTION_DESCRIPTION_PLACEHOLDER]:
    "Describe your collection...",
  [LocalizationKeys.COLLECTION_IMAGE_URL]: "Cover image URL",
  [LocalizationKeys.COLLECTION_IMAGE_URL_PLACEHOLDER]:
    "https://example.com/image.jpg",

  // Collection delete keys
  [LocalizationKeys.COLLECTION_DELETE_TITLE]: "Delete Collection",
  [LocalizationKeys.COLLECTION_DELETE_CONFIRM_MESSAGE]:
    "Are you sure you want to delete this collection? This action cannot be undone.",

  // Content details page keys
  [LocalizationKeys.CONTENT_DETAILS_PIN_CONTENT]: "Pin content",
  [LocalizationKeys.CONTENT_DETAILS_ADD_TO_COLLECTION]: "To collection",
  [LocalizationKeys.CONTENT_DETAILS_CHANGE_CONSUME_TYPE]: "Change consume type",
  [LocalizationKeys.CONTENT_DETAILS_TOGGLE_FAVOURITE]: "To Favourite",
  [LocalizationKeys.CONTENT_DETAILS_OPEN_DISCUSSION]: "Discuss",
  [LocalizationKeys.CONTENT_DETAILS_OPEN_SETTINGS]: "Settings",
  [LocalizationKeys.CONTENT_DETAILS_RATE_CONTENT]: "Rate content",
  [LocalizationKeys.CONTENT_DETAILS_EXTERNAL_RATINGS]: "External ratings",
  [LocalizationKeys.CONTENT_DETAILS_CHILD_CONTENT]: "Child content",
  [LocalizationKeys.CONTENT_DETAILS_REVIEWS]: "Reviews",
  [LocalizationKeys.CONTENT_DETAILS_COLLECTIONS]: "Collections",
  [LocalizationKeys.CONTENT_DETAILS_PARTICIPANTS]: "Participants",
  [LocalizationKeys.CONTENT_DETAILS_GENRES]: "Genres",
  [LocalizationKeys.CONTENT_DETAILS_YOUR_RATING]: "Your rating",
  [LocalizationKeys.CONTENT_DETAILS_COMMUNITY_RATING]: "Our rating",
  [LocalizationKeys.CONTENT_DETAILS_RATE_THIS]: "Rate this",
  [LocalizationKeys.CONTENT_DETAILS_REVIEWS_COUNT]: "{0} reviews",
  [LocalizationKeys.CONTENT_DETAILS_DESCRIPTION]: "Description",
  [LocalizationKeys.CONTENT_DETAILS_CONTINUE]: "Continue ➜",
  [LocalizationKeys.CONTENT_DETAILS_DURATION_MINUTES]: "minutes",
  [LocalizationKeys.CONTENT_DETAILS_DURATION_HOURS]: "hours",
  [LocalizationKeys.CONTENT_DETAILS_DURATION_PAGES]: "pages",
  [LocalizationKeys.CONTENT_DETAILS_RELEASE_DATE]: "Release date",
  [LocalizationKeys.CONTENT_DETAILS_STATUS]: "Status",
  [LocalizationKeys.CONTENT_DETAILS_CERTIFICATE]: "Age rating",
  [LocalizationKeys.CONTENT_DETAILS_EPISODE_COUNT]: "Episode count",
  [LocalizationKeys.CONTENT_DETAILS_AVG_EPISODE_DURATION]:
    "Average episode duration",

  // Context menu keys
  [LocalizationKeys.CONTEXT_MENU_PIN]: "Pin",
  [LocalizationKeys.CONTEXT_MENU_UNPIN]: "Unpin",
  [LocalizationKeys.CONTEXT_MENU_FAVOURITE]: "Favourite",
  [LocalizationKeys.CONTEXT_MENU_CONSUME]: "Consume",
  [LocalizationKeys.CONTEXT_MENU_SHARE]: "Share",
  [LocalizationKeys.CONTEXT_MENU_REPORT]: "Report",
  [LocalizationKeys.CONTEXT_MENU_LOGOUT]: "Logout",

  // Affiliate settings keys
  [LocalizationKeys.AFFILIATE_SETTINGS_TITLE]: "Content Settings",
  [LocalizationKeys.AFFILIATE_SETTINGS_LINK]: "Content Link",
  [LocalizationKeys.AFFILIATE_SETTINGS_LINK_PLACEHOLDER]: "Enter link",
  [LocalizationKeys.AFFILIATE_SETTINGS_VARIANT]: "Variant",
  [LocalizationKeys.AFFILIATE_SETTINGS_VARIANT_PLACEHOLDER]:
    "Dubbing / Edition",
  [LocalizationKeys.AFFILIATE_SETTINGS_SAVE]: "Save",
  [LocalizationKeys.AFFILIATE_SETTINGS_CANCEL]: "Cancel",

  // Navigator keys
  [LocalizationKeys.NAVIGATOR_TITLE]: "Navigator",
  [LocalizationKeys.NAVIGATOR_EXPAND_ALL]: "Expand all",
  [LocalizationKeys.NAVIGATOR_COLLAPSE_ALL]: "Collapse all",
  [LocalizationKeys.NAVIGATOR_EXPAND]: "Expand",
  [LocalizationKeys.NAVIGATOR_COLLAPSE]: "Collapse",
  [LocalizationKeys.NAVIGATOR_MARK_WATCHED]: "Mark watched",
  [LocalizationKeys.NAVIGATOR_RATE]: "Rate",

  // Reviews keys
  [LocalizationKeys.REVIEWS_USER_HAS_REVIEW]:
    "You still have no reviews for this content. You can share your thoughts by writing a review!",
  [LocalizationKeys.REVIEWS_NO_REVIEWS]: "No reviews for this content yet.",
  [LocalizationKeys.REVIEWS_WRITE_REVIEW]: "Write a review",
  [LocalizationKeys.REVIEWS_SAVE]: "Save review",
  [LocalizationKeys.REVIEWS_CANCEL]: "Cancel",
  [LocalizationKeys.REVIEWS_PLACEHOLDER]:
    "Share your thoughts about this content...",
  [LocalizationKeys.REVIEWS_FORMATTING_BOLD]: "Bold (Ctrl+B)",
  [LocalizationKeys.REVIEWS_FORMATTING_ITALIC]: "Italic (Ctrl+I)",
  [LocalizationKeys.REVIEWS_FORMATTING_UNDERLINE]: "Underline (Ctrl+U)",
  [LocalizationKeys.REVIEWS_FORMATTING_STRIKETHROUGH]: "Strikethrough",
  [LocalizationKeys.REVIEWS_FORMATTING_HEADING]: "Heading",
  [LocalizationKeys.REVIEWS_FORMATTING_QUOTE]: "Quote",
  [LocalizationKeys.REVIEWS_FORMATTING_LIST]: "List",
  [LocalizationKeys.REVIEWS_FORMATTING_LINK]: "Link",
  [LocalizationKeys.REVIEWS_VIEW_ALL]: "View all",
  [LocalizationKeys.REVIEWS_PAGE_TITLE]: 'Reviews for "{0}"',
  [LocalizationKeys.REVIEWS_BACK_TO_CONTENT]: "Back to content",
  [LocalizationKeys.REVIEWS_SORT_BY_DATE]: "By date",
  [LocalizationKeys.REVIEWS_SORT_BY_USEFULNESS]: "By usefulness",
  [LocalizationKeys.REVIEWS_SORT_BY_REPUTATION]: "By reputation",
  [LocalizationKeys.REVIEWS_SORT_ASC]: "Ascending",
  [LocalizationKeys.REVIEWS_SORT_DESC]: "Descending",
  [LocalizationKeys.REVIEWS_FILTER_LANGUAGE]: "Language",
  [LocalizationKeys.REVIEWS_HIDE_NEGATIVE]: "Only with positive reputation",
  [LocalizationKeys.REVIEWS_TOTAL_COUNT]: "{0} reviews",
  [LocalizationKeys.REVIEWS_TITLE]: "Title",
  [LocalizationKeys.REVIEWS_TITLE_PLACEHOLDER]: "Enter review title...",
  [LocalizationKeys.REVIEWS_SAVE_ERROR]:
    "Failed to save review. Please try again.",

  [LocalizationKeys.REVIEW_EDIT]: "Edit",
  [LocalizationKeys.REVIEW_EDIT_TITLE]: "Edit Review",
  [LocalizationKeys.REVIEW_DELETE]: "Delete",
  [LocalizationKeys.REVIEW_DELETE_TITLE]: "Delete Review",
  [LocalizationKeys.REVIEW_DELETE_CONFIRM_MESSAGE]:
    "Are you sure you want to delete your review?",
  [LocalizationKeys.REVIEW_CONFIRM_DELETE]: "Confirm deletion",
  [LocalizationKeys.REVIEW_CONFIRM_DELETE_TEXT]:
    "Are you sure you want to delete this review? This action cannot be undone.",
  [LocalizationKeys.REVIEW_CANCEL]: "Cancel",
  [LocalizationKeys.REVIEW_AUTHOR_RATING]: "Author's rating",
  [LocalizationKeys.REVIEW_CREATED_AT]: "Created",
  [LocalizationKeys.REVIEW_UPDATED_AT]: "Updated",
  [LocalizationKeys.REVIEW_LOADING]: "Loading review...",
  [LocalizationKeys.REVIEW_ERROR]: "Failed to load review",
  [LocalizationKeys.REVIEW_NOT_FOUND]: "Review not found",
  [LocalizationKeys.REVIEW_GO_TO_CONTENT]: "Go to Content",
  [LocalizationKeys.REVIEW_GO_TO_ALL_REVIEWS]: "All Reviews",
  [LocalizationKeys.REVIEW_TO_CONTENT]: "To content",
  [LocalizationKeys.REVIEW_TO_ALL_REVIEWS]: "To all reviews",
  [LocalizationKeys.REVIEW_OF]: "Review of",
  [LocalizationKeys.REVIEW_ON]: "about",
  [LocalizationKeys.REVIEW_AUTHOR_GAVE_RATING]: "Rated",
  [LocalizationKeys.REVIEW_COMMENTS_SECTION]: "Comments",
  [LocalizationKeys.REVIEW_COMMENTS_PLACEHOLDER]:
    "Comments section will be implemented soon",

  // Comments section keys
  [LocalizationKeys.COMMENTS_SECTION_TITLE]: "Comments",
  [LocalizationKeys.COMMENTS_WRITE_COMMENT]: "Write a comment",
  [LocalizationKeys.COMMENTS_REPLY]: "Reply",
  [LocalizationKeys.COMMENTS_CANCEL]: "Cancel",
  [LocalizationKeys.COMMENTS_PUBLISH]: "Post comment",
  [LocalizationKeys.COMMENTS_EDIT]: "Edit",
  [LocalizationKeys.COMMENTS_DELETE]: "Delete",
  [LocalizationKeys.COMMENTS_SHARE]: "Share",
  [LocalizationKeys.COMMENTS_REPORT]: "Report",
  [LocalizationKeys.COMMENTS_VIEW_MORE]: "View more comments",
  [LocalizationKeys.COMMENTS_LOAD_MORE_REPLIES]: "Load more replies",
  [LocalizationKeys.COMMENTS_SHOW_REPLIES]: "Show replies",
  [LocalizationKeys.COMMENTS_HIDE_REPLIES]: "Hide replies",
  [LocalizationKeys.COMMENTS_REPLY_COUNT]: "{0} replies",
  [LocalizationKeys.COMMENTS_ACTIONS_LABEL]: "Comment actions",
  [LocalizationKeys.COMMENTS_EXPAND]: "Expand",
  [LocalizationKeys.COMMENTS_COLLAPSE]: "Collapse",
  [LocalizationKeys.COMMENTS_PLACEHOLDER]: "Write your comment...",
  [LocalizationKeys.COMMENTS_CREATED_AT]: "Posted",
  [LocalizationKeys.COMMENTS_UPDATED_AT]: "Updated",
  [LocalizationKeys.COMMENTS_EDITED]: "(edited)",
  [LocalizationKeys.COMMENTS_DELETE_CONFIRM]: "Delete comment?",
  [LocalizationKeys.COMMENTS_DELETE_CONFIRM_MESSAGE]:
    "Are you sure you want to delete this comment? This action cannot be undone.",
  [LocalizationKeys.COMMENTS_SAVE_ERROR]: "Failed to save comment",
  [LocalizationKeys.COMMENTS_DELETE_ERROR]: "Failed to delete comment",
  [LocalizationKeys.COMMENTS_LOAD_ERROR]: "Failed to load comments",
  [LocalizationKeys.COMMENTS_NO_COMMENTS]:
    "No comments yet. Be the first to comment!",
  [LocalizationKeys.COMMENTS_REPLYING_TO]: "Replying to",

  // Person page keys
  [LocalizationKeys.PERSON_BIRTH_DATE]: "Birth Date",
  [LocalizationKeys.PERSON_DEATH_DATE]: "Death Date",
  [LocalizationKeys.PERSON_AGE]: "age",
  [LocalizationKeys.PERSON_YEARS]: "years",
  [LocalizationKeys.PERSON_GENDER]: "Gender",
  [LocalizationKeys.PERSON_HEIGHT]: "Height",
  [LocalizationKeys.PERSON_HEIGHT_CM]: "cm",
  [LocalizationKeys.PERSON_BIRTH_PLACE]: "Birth Place",
  [LocalizationKeys.PERSON_SPOUSE]: "Spouse",
  [LocalizationKeys.PERSON_BIOGRAPHY]: "Biography",
  [LocalizationKeys.PERSON_KNOWN_FOR]: "Known for",
  [LocalizationKeys.PERSON_PARTICIPATED_IN]: "Participated as",
  [LocalizationKeys.PERSON_FAVOURITE_COUNT]: "Favorites",
  [LocalizationKeys.PERSON_MESSAGE_COUNT]: "Messages",

  // Position Type keys
  [LocalizationKeys.POSITION_TYPE_UNSPECIFIED]: "Not specified",
  [LocalizationKeys.POSITION_TYPE_DIRECTOR]: "Director",
  [LocalizationKeys.POSITION_TYPE_WRITER]: "Writer",
  [LocalizationKeys.POSITION_TYPE_ACTOR]: "Actor",
  [LocalizationKeys.POSITION_TYPE_PRODUCER]: "Producer",
  [LocalizationKeys.POSITION_TYPE_CINEMATOGRAPHER]: "Cinematographer",
  [LocalizationKeys.POSITION_TYPE_EDITOR]: "Editor",
  [LocalizationKeys.POSITION_TYPE_COMPOSER]: "Composer",
  [LocalizationKeys.POSITION_TYPE_VOICE_ACTOR]: "Voice Actor",

  // Pagination keys
  [LocalizationKeys.PAGINATION_PREVIOUS]: "←",
  [LocalizationKeys.PAGINATION_NEXT]: "→",
  [LocalizationKeys.PAGINATION_FIRST]: "First",
  [LocalizationKeys.PAGINATION_LAST]: "Last",

  // Sort keys
  [LocalizationKeys.SORT_BY]: "Sort by",
  [LocalizationKeys.SORT_BY_NEWEST]: "Newest",
  [LocalizationKeys.SORT_BY_OLDEST]: "Oldest",
  [LocalizationKeys.SORT_BY_POPULAR]: "Most popular",
  [LocalizationKeys.SORT_BY_RATING]: "Highest rated",
  [LocalizationKeys.SORT_NEWEST]: "Newest",
  [LocalizationKeys.SORT_OLDEST]: "Oldest",
  [LocalizationKeys.SORT_HIGHEST_REPUTATION]: "Highest reputation",
  [LocalizationKeys.SORT_LOWEST_REPUTATION]: "Lowest reputation",
  [LocalizationKeys.SORT_MOST_USEFUL]: "Most useful",
  [LocalizationKeys.SORT_LEAST_USEFUL]: "Least useful",
  [LocalizationKeys.SORT_HIGHEST_RATING]: "Highest rating",
  [LocalizationKeys.SORT_LOWEST_RATING]: "Lowest rating",
  [LocalizationKeys.SORT_NAME_ASC]: "A to Z",
  [LocalizationKeys.SORT_NAME_DESC]: "Z to A",

  // Collections list keys
  [LocalizationKeys.COLLECTIONS_NO_COLLECTIONS_FOUND]: "No collections found",
  [LocalizationKeys.COLLECTIONS_LOADING]: "Loading collections...",
  [LocalizationKeys.COLLECTIONS_ONLY_MY_COLLECTIONS]: "Only my collections",
  [LocalizationKeys.COLLECTIONS_OF_CONTENT]: "Collections with",
  [LocalizationKeys.COLLECTIONS_TO_ALL_COLLECTIONS]: "To all collections",

  // User collections page keys
  [LocalizationKeys.USER_COLLECTIONS_TOTAL]: "Total Collections",
  [LocalizationKeys.USER_COLLECTIONS_AVG_REPUTATION]: "Avg. Reputation",
  [LocalizationKeys.USER_COLLECTIONS_TOTAL_FAVOURITES]: "Total Favourites",
  [LocalizationKeys.USER_COLLECTIONS_TOTAL_COMMENTS]: "Total Comments",
  [LocalizationKeys.USER_COLLECTIONS_EMPTY]: "No collections yet",
  [LocalizationKeys.USER_COLLECTIONS_TITLE]: "Collections",
  [LocalizationKeys.USER_COLLECTIONS_SORT_BY_DATE]: "Sort by Date",
  [LocalizationKeys.USER_COLLECTIONS_SORT_BY_REPUTATION]: "Sort by Reputation",
  [LocalizationKeys.USER_COLLECTIONS_SORT_BY_USEFULNESS]: "Sort by Usefulness",

  // User profile page keys
  [LocalizationKeys.USER_PAGE_FOLLOW]: "Follow",
  [LocalizationKeys.USER_PAGE_FOLLOWING]: "Following",
  [LocalizationKeys.USER_PAGE_UNFOLLOW]: "Unfollow",
  [LocalizationKeys.USER_PAGE_FOLLOWERS]: "Followers",
  [LocalizationKeys.USER_PAGE_REVIEWS]: "Reviews",
  [LocalizationKeys.USER_PAGE_COLLECTIONS]: "Collections",
  [LocalizationKeys.USER_PAGE_LIBRARY]: "Library",
  [LocalizationKeys.USER_PAGE_MY_LIBRARY]: "My Library",
  [LocalizationKeys.USER_PAGE_FAVOURITES]: "Favourites",
  [LocalizationKeys.USER_PAGE_MY_FAVOURITES]: "My Favourites",
  [LocalizationKeys.USER_PAGE_CREATED_COLLECTIONS]: "Created Collections",
  [LocalizationKeys.USER_PAGE_VIEW_ALL_COLLECTIONS]: "View All Collections",
  [LocalizationKeys.USER_PAGE_TOP_REVIEWS]: "Top Reviews",
  [LocalizationKeys.USER_PAGE_VIEW_ALL_REVIEWS]: "View All Reviews",
  [LocalizationKeys.USER_PAGE_ACTIVITY_CALENDAR]: "Activity Calendar",
  [LocalizationKeys.USER_PAGE_ACTIVITY_CALENDAR_DESC]:
    "GitHub-style activity calendar showing user engagement over time.",
  [LocalizationKeys.USER_PAGE_PLATFORM_HISTORY]: "Platform Activity History",
  [LocalizationKeys.USER_PAGE_PLATFORM_HISTORY_DESC]:
    "Recent actions and interactions on the platform.",
  [LocalizationKeys.USER_PAGE_ACIVEMENT_SECTION]: "Achivement section",
  [LocalizationKeys.USER_PAGE_ACIVEMENT_SECTION_DESC]:
    "Horizontal scroll with user Achivement",

  // User follows page keys
  [LocalizationKeys.USER_FOLLOWS_PAGE_FOLLOWERS_TAB]: "Followers",
  [LocalizationKeys.USER_FOLLOWS_PAGE_FOLLOWING_TAB]: "Following",
  [LocalizationKeys.USER_FOLLOWS_PAGE_NO_FOLLOWERS]: "No followers yet",
  [LocalizationKeys.USER_FOLLOWS_PAGE_NO_FOLLOWING]: "Not following anyone yet",
  [LocalizationKeys.USER_FOLLOWS_PAGE_LOADING]: "Loading users...",

  // User stats keys
  [LocalizationKeys.USER_STATS_OVERVIEW]: "Statistics Overview",
  [LocalizationKeys.USER_STATS_REVIEWS]: "Reviews",
  [LocalizationKeys.USER_STATS_COLLECTIONS]: "Collections",
  [LocalizationKeys.USER_STATS_COMMENTS]: "Comments",
  [LocalizationKeys.USER_STATS_FAVOURITES]: "Favourites",
  [LocalizationKeys.USER_STATS_TOTAL_CONSUMED]: "Total Consumed",
  [LocalizationKeys.USER_STATS_ITEMS]: "Items",
  [LocalizationKeys.USER_STATS_WATCH_TIME]: "Watch Time",
  [LocalizationKeys.USER_STATS_PAGES_READ]: "Pages Read",
  [LocalizationKeys.USER_STATS_DAYS]: "days",
  [LocalizationKeys.USER_STATS_HOURS]: "hours",
  [LocalizationKeys.USER_STATS_MINUTES]: "min",
  [LocalizationKeys.USER_STATS_PAGES]: "pages",

  // Favourite widget keys
  [LocalizationKeys.FAVOURITE_WIDGET_NO_CONTENT]:
    "User has no favourite content yet",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_CONTENT_CURRENT_USER]:
    "You have no favourite content yet",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_PEOPLE]:
    "User has no favourite people yet",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_PEOPLE_CURRENT_USER]:
    "You have no favourite people yet",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_COLLECTIONS]:
    "User has no favourite collections yet",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_COLLECTIONS_CURRENT_USER]:
    "You have no favourite collections yet",

  // Library widget keys
  [LocalizationKeys.LIBRARY_WIDGET_NO_CONTENT]: "User has no {0} {1} yet",
  [LocalizationKeys.LIBRARY_WIDGET_NO_CONTENT_CURRENT_USER]:
    "You have no {0} {1} yet",

  // Toast notification keys
  [LocalizationKeys.TOAST_AUTH_WELCOME_BACK]: "Welcome back!",
  [LocalizationKeys.TOAST_AUTH_ACCOUNT_CREATED]:
    "Account created successfully! Welcome!",
  [LocalizationKeys.TOAST_AUTH_SESSION_EXPIRED]:
    "Session expired. Please sign in again.",
  [LocalizationKeys.TOAST_AUTH_PROFILE_LOAD_FAILED]:
    "Failed to load user profile",

  [LocalizationKeys.TOAST_DEV_MOCK_DATA_LOADED]:
    "Development mode: Using mock data",

  [LocalizationKeys.TOAST_REVIEW_CREATED]: "Review created successfully!",
  [LocalizationKeys.TOAST_REVIEW_SAVED]: "Review saved successfully!",
  [LocalizationKeys.TOAST_REVIEW_FILL_REQUIRED]:
    "Please fill in both title and body",

  [LocalizationKeys.TOAST_COLLECTION_SAVED]: "Collection saved successfully!",
  [LocalizationKeys.TOAST_COLLECTION_UPDATED]:
    "Collection updated successfully!",
  [LocalizationKeys.TOAST_COLLECTION_DELETED]:
    "Collection deleted successfully!",
  [LocalizationKeys.TOAST_COLLECTION_TITLE_REQUIRED]:
    "Please enter a collection title",

  [LocalizationKeys.TOAST_AFFILIATE_SAVED]:
    "Affiliate settings saved successfully!",

  [LocalizationKeys.TOAST_ERROR_GENERIC]: "An unexpected error occurred",
  [LocalizationKeys.TOAST_ERROR_NETWORK]:
    "Network error. Please check your connection.",
  [LocalizationKeys.TOAST_ERROR_SAVE_FAILED]: "Failed to save changes",

  [LocalizationKeys.TOAST_VALIDATION_REQUIRED_FIELDS]:
    "Please fill in all required fields",
  [LocalizationKeys.TOAST_VALIDATION_FILL_ALL_FIELDS]:
    "Please fill in all fields correctly",

  // Pin action toast keys
  [LocalizationKeys.TOAST_CONTENT_PINNED]: "Content pinned successfully!",
  [LocalizationKeys.TOAST_CONTENT_UNPINNED]: "Content unpinned successfully!",
  [LocalizationKeys.TOAST_CONTENT_PIN_ERROR]: "Failed to pin content",
  [LocalizationKeys.TOAST_CONTENT_UNPIN_ERROR]: "Failed to unpin content",

  // Follow action toast keys
  [LocalizationKeys.TOAST_USER_FOLLOWED]: "Successfully followed user!",
  [LocalizationKeys.TOAST_USER_UNFOLLOWED]: "Successfully unfollowed user!",
  [LocalizationKeys.TOAST_USER_FOLLOW_ERROR]: "Failed to follow user",
  [LocalizationKeys.TOAST_USER_UNFOLLOW_ERROR]: "Failed to unfollow user",

  // Edit/Delete action toast keys
  [LocalizationKeys.TOAST_ITEM_DELETED]: "Item deleted successfully!",
  [LocalizationKeys.TOAST_ITEM_DELETE_ERROR]: "Failed to delete item",
  [LocalizationKeys.TOAST_ITEM_UPDATED]: "Item updated successfully!",
  [LocalizationKeys.TOAST_ITEM_UPDATE_ERROR]: "Failed to update item",

  // Favourite action toast keys
  [LocalizationKeys.TOAST_FAVOURITE_ADDED]: "Added to favourites!",
  [LocalizationKeys.TOAST_FAVOURITE_REMOVED]: "Removed from favourites",
  [LocalizationKeys.TOAST_FAVOURITE_MUTED]: "Notifications muted",
  [LocalizationKeys.TOAST_FAVOURITE_UNMUTED]: "Notifications enabled",
  [LocalizationKeys.TOAST_FAVOURITE_ADD_ERROR]: "Failed to add to favourites",
  [LocalizationKeys.TOAST_FAVOURITE_REMOVE_ERROR]:
    "Failed to remove from favourites",
  [LocalizationKeys.TOAST_FAVOURITE_UPDATE_ERROR]:
    "Failed to update favourite settings",

  // Rating action toast keys
  [LocalizationKeys.TOAST_RATING_ADDED]: "Rating added!",
  [LocalizationKeys.TOAST_RATING_UPDATED]: "Rating updated!",
  [LocalizationKeys.TOAST_RATING_REMOVED]: "Rating removed",
  [LocalizationKeys.TOAST_RATING_ERROR]: "Failed to save rating",

  // Consume action toast keys
  [LocalizationKeys.TOAST_CONSUME_WATCHING]: "Marked as watching!",
  [LocalizationKeys.TOAST_CONSUME_WATCHED]: "Marked as watched!",
  [LocalizationKeys.TOAST_CONSUME_DELAYED]: "Added to delayed",
  [LocalizationKeys.TOAST_CONSUME_TRASH]: "Moved to dropped",
  [LocalizationKeys.TOAST_CONSUME_REMOVED]: "Status removed",
  [LocalizationKeys.TOAST_CONSUME_ERROR]: "Failed to update status",

  // Reputation action toast keys
  [LocalizationKeys.TOAST_REPUTATION_LIKED]: "You liked this!",
  [LocalizationKeys.TOAST_REPUTATION_DISLIKED]: "Disliked",
  [LocalizationKeys.TOAST_REPUTATION_REMOVED]: "Rating removed",
  [LocalizationKeys.TOAST_REPUTATION_ERROR]: "Failed to rate",

  // Share action toast keys
  [LocalizationKeys.TOAST_LINK_COPIED]: "Link copied to clipboard",
  [LocalizationKeys.TOAST_LINK_COPY_ERROR]: "Failed to copy link",

  ...enRegionTranslations,
} as Translations;
